var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFaceButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-116.666 -46.668)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.02,46.668a4.35,4.35,0,0,0-4.35,4.35v3.625a1.45,1.45,0,1,0,2.9,0V51.018a1.45,1.45,0,0,1,1.45-1.45h3.625a1.45,1.45,0,1,0,0-2.9Z",
    transform: "translate(-0.004)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.118,46.668a1.45,1.45,0,1,0,0,2.9h3.625a1.45,1.45,0,0,1,1.45,1.45v3.625a1.45,1.45,0,1,0,2.9,0V51.018a4.35,4.35,0,0,0-4.35-4.35Z",
    transform: "translate(-295.427)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.566,363.118a1.45,1.45,0,0,0-2.9,0v3.625a4.35,4.35,0,0,0,4.35,4.35h3.625a1.45,1.45,0,0,0,0-2.9h-3.625a1.45,1.45,0,0,1-1.45-1.45Z",
    transform: "translate(0 -295.425)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.091,363.118a1.45,1.45,0,1,0-2.9,0v3.625a1.45,1.45,0,0,1-1.45,1.45h-3.625a1.45,1.45,0,0,0,0,2.9h3.625a4.35,4.35,0,0,0,4.35-4.35Z",
    transform: "translate(-295.425 -295.425)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.66,116.67a8.99,8.99,0,1,0,8.99,8.99A8.99,8.99,0,0,0,195.66,116.67Zm-4.244,10.569a1.284,1.284,0,0,1,1.808.17,3,3,0,0,0,4.871,0,1.284,1.284,0,0,1,1.978,1.639,5.563,5.563,0,0,1-8.827,0,1.285,1.285,0,0,1,.17-1.808Z",
    transform: "translate(-64.654 -64.207)",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceButton);
export default __webpack_public_path__ + "static/media/faceButton.6911ee7193b4e95b9191b210c087a7ff.svg";
export { ForwardRef as ReactComponent };